module.exports = __webpack_public_path__ + "static/media/bowl.6ff3ab42.jpg";